import { authApi } from '../../../../common/redux/services/auth';
import { ghostnewsServiceURL } from '../../../../common/redux/services/defines';
import BaseReduxService from '../../../../redux/BaseReduxService';

class AgentFeedsReduxService extends BaseReduxService {
  constructor() {
    super(ghostnewsServiceURL, '/agn-feeds');
  }

  injectEndpoints() {
    return authApi.injectEndpoints({
      endpoints: (builder) => ({
        ...this.createEndpoints(builder, 'AgentFeeds'),
        // Manual override: push a feed that didn't pass the relevance/dedup
        // gate (discard / error / duplicated) into the writing pipeline.
        // Hits the agn-candidates from-feed endpoint which re-scrapes the
        // feed's link, creates a candidate and runs research+write.
        sendFeedToWriting: builder.mutation({
          query: ({ feedID, taskID }) => ({
            url: `${ghostnewsServiceURL}/agn-candidates/from-feed/${feedID}/${taskID}`,
            method: 'POST',
          }),
          invalidatesTags: ['AgentFeeds'],
        }),
      }),
    });
  }
}

const AgentFeedsService = new AgentFeedsReduxService();

export const {
  useAgentFeedsFetchItemsQuery: useFetchAgentFeedsQuery,
  useAgentFeedsFetchItemByIdQuery: useFetchAgentFeedsByIdQuery,
  useAgentFeedsCreateItemMutation: useCreateAgentFeedsMutation,
  useAgentFeedsUpdateItemMutation: useUpdateAgentFeedsMutation,
  useAgentFeedsDeleteItemMutation: useDeleteAgentFeedsMutation,
  useSendFeedToWritingMutation,
} = AgentFeedsService.injectEndpoints();
